import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import { LISTING_STATE_DRAFT } from '../../util/types';
import { ensureListing } from '../../util/data';
import { EditListingLanguagesForm } from '../../forms';
import { ListingLink } from '../../components';

import css from './EditListingLanguagesPanel.module.css';

const LANGUAGES_NAME = 'languages';

const EditListingLanguagesPanel = props => {
  const {
    rootClassName,
    className,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureListing(listing);
  const { publicData = {}} = currentListing.attributes;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingLanguagesPanel.title"
      values={{ listingTitle: <ListingLink listing={listing} /> }}
    />
  ) : (
    <FormattedMessage id="EditListingLanguagesPanel.createListingTitle" />
  );
  const panelSubtitle = (
    <FormattedMessage
      id="EditListingLanguagesPanel.subtitle"
      values={{ br: <br/>, pleaseNote: <b>Please note:</b>}}
    />
  );

  const { anotherLanguage, languages = []} = publicData;
  const initialValues = { anotherLanguage, languages };

  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>
      <div className={css.subtitle}>{panelSubtitle}</div>
      <EditListingLanguagesForm
        className={css.form}
        name={LANGUAGES_NAME}
        initialValues={initialValues}
        onSubmit={values => {
          const { languages = [], anotherLanguage } = values;

          const updatedValues = {
            publicData: { languages, anotherLanguage },
          };
          onSubmit(updatedValues);
        }}
        onChange={onChange}
        saveActionMsg={submitButtonText}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
      />
    </div>
  );
};

EditListingLanguagesPanel.defaultProps = {
  rootClassName: null,
  className: null,
  listing: null,
};

const { bool, func, object, string } = PropTypes;

EditListingLanguagesPanel.propTypes = {
  rootClassName: string,
  className: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingLanguagesPanel;
